import React from 'react';
import { WorkImage } from '../workDetailPage/WorkImage';

interface WorkImageGroupProps {
    images: string[];
    description?: string;
}

const WorkImageGroup: React.FC<WorkImageGroupProps> = ({ images, description }) => {
    // 최대 3개까지만 허용
    const displayImages = images.slice(0, 3);
    
    return (
        <div className="image-group-container" style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '20px', 
            margin: '40px auto', 
            maxWidth: '1400px',
            padding: '0 40px',
            alignItems: 'center' 
        }}>
            <div style={{ 
                display: 'flex', 
                flexDirection: 'row', 
                gap: '12px', 
                maxHeight: '400px', 
                alignItems: 'center', 
                overflow: 'hidden', 
                justifyContent: 'center' 
            }}>
                {displayImages.map((image, index) => (
                    <div 
                        key={index}
                        style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            height: '100%', 
                            overflow: 'hidden', 
                            borderRadius: '24px', 
                            width: 'auto'
                        }}
                    >
                        <img 
                            src={image}
                            style={{
                                maxHeight: '400px',
                                height: 'auto',
                                width: 'auto',
                                objectFit: 'contain',
                                borderRadius: '24px'
                            }}
                        />
                    </div>
                ))}
            </div>
            {description && (
                <div className="imageCaption">
                    {description}
                </div>
            )}
        </div>
    );
};

export default WorkImageGroup;
